<div fxFlexFill class="BackgroundContainer">
    <div class="container _aptis--login-container">
        <div class="divImage">
            <img class="logoImage" src="assets/images/aptumLogo.svg" />
        </div>
        <div class="formContainer formLoginStyles" id="divContentLogIn" fxLayout="column" fxLayoutAlign="space-around center">
            <abc-authentication-login></abc-authentication-login>
        </div>
    </div>
</div>
